import { render, staticRenderFns } from "./UnloadingFilterBids.vue?vue&type=template&id=bb54685a&"
import script from "./UnloadingFilterBids.vue?vue&type=script&lang=js&"
export * from "./UnloadingFilterBids.vue?vue&type=script&lang=js&"
import style0 from "./UnloadingFilterBids.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports